import AbstractElectronOperatorApplicationPlatform
    from "~/operatorApplication/ts/platform/electron/AbstractElectronOperatorApplicationPlatform";
import Electron22PlatformUpdater from "~/operatorApplication/ts/platform/electron/Electron22PlatformUpdater";


export default class Electron22OperatorApplicationPlatform extends AbstractElectronOperatorApplicationPlatform {
    protected createUpdaterInstance(): Electron22PlatformUpdater {
        return new Electron22PlatformUpdater(this);
    }
}